// LEGACY (flag: partner_dashboard_service_pricing_proof OFF).
//
// This reproduces the pre-IOPS-5300 manual-studio pricing inputs exactly as
// they shipped on `main`: a "My prices are not listed online" checkbox, the
// service-price field, and a REQUIRED link-to-pricing field — no file upload,
// no accountability checkbox. It renders only on the add (input) flow for
// manual studios when the feature flag is off, as the dark-launch fallback.
//
// Submit-side counterpart: `createServicePricing` in ServiceForm.js (URL-only
// proof, accountability_agreement: false, not_listed_online sentinel).
//
// Delete this file, its usage in ServiceForm.js, and `createServicePricing`
// when the flag is retired.
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { Checkbox, Input, CurrencyInput } from 'components/HookForm';
import InfoBanner from 'components/InfoBanner/InfoBanner';
import Message from 'components/Message';
import When from 'components/When';

import { ICONS } from 'constants/icons';
import { URL_SIMPLE_REGEX } from 'constants/logic';

import { bem } from 'helpers/class-name';

import { selectActiveVenue } from 'selectors/general';
import { selectLocaleData } from 'selectors/locale-data';

import { messages } from '../../Components/ServicePricingSection/ServicePricingSection.messages';

const { element } = bem('service-form');

const LegacyServicePricingInputs = () => {
  const { watch } = useFormContext();
  const notListedOnline = watch('notListedOnline');

  const venue = useSelector(selectActiveVenue);
  const { locale } = useSelector(selectLocaleData);

  const servicePriceDescriptionMessage =
    venue.countryCode === 'USA' ? messages.servicePriceDescriptionUSA : messages.servicePriceDescription;

  return (
    <>
      <hr className="mv+" />

      <Message as="p" message={messages.pricing} className="text--medium text--semibold" />

      <InfoBanner icon={ICONS.infoBrand} subtitle={messages.pricingInfoBanner} hideCTA />

      <Checkbox name="notListedOnline" margin>
        <Message message={messages.notListedOnline} className={element('input-label')} />
      </Checkbox>

      <CurrencyInput
        name="servicePrice"
        currencyCode={venue.currencyCode}
        locale={locale}
        label={messages.servicePrice}
        required
        showRequiredLabel
        noMargin
        data-cypress="service-price"
      />
      <Message as="p" message={servicePriceDescriptionMessage} className={element('input-description')} />

      <When predicate={!notListedOnline}>
        <Input
          name="linkToPrice"
          type="text"
          label={messages.linkToPrice}
          labelTooltip={messages.linkToPriceTooltip}
          placeholder={messages.linkToPricePlaceholder}
          pattern={{
            value: URL_SIMPLE_REGEX,
            message: messages.invalidUrl,
          }}
          required
          showRequiredLabel
          noMargin
          data-cypress="link-to-price"
        />
        <Message as="p" message={messages.linkToPriceDescription} className={element('input-description')} />
      </When>
    </>
  );
};

export default LegacyServicePricingInputs;
